import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function dineinchecking(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/dineinchecking', data, { params: new_params })
}

export function delieverytimes(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/delieverytimes/' + id, { params: new_params })
}

export function getDataTable(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/posrestolayout', { params: new_params })
}

export function getDataDetailTable(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/posrestolayout/' + id, { params: new_params })
}

export function getDataDetailTableItem(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/posrestolayoutitems/' + id, { params: new_params })
}

export function reserveTimes(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/reservation', { params: new_params })
}

export function checkReserve(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/reservation/checkreservationavailability', data, { params: new_params })
}

export function checkRounding(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/rounding/calculate', data, { params: new_params })
}
